var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a5muamcnca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25h-.75V3a2.25 2.25 0 1 0-4.5 0v2.25H3a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75V6A.75.75 0 0 0 9 5.25zM4.5 3a1.5 1.5 0 0 1 3 0v2.25h-3V3zM9 10.5H3V6h6v4.5z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5V6h6v4.5H3z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.5,
    r: 0.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5v2.25",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a5muamcnca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.73d6d20f2ee6ea3b77b797a1045db382.svg";
export { ForwardRef as ReactComponent };